import React from 'react';

import TextField from '@atlaskit/textfield';

import Field from 'src/views/components/Form/Field';

const Name = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur }) => {
  return (
    <Field label="Rule name" isRequired errorMessage={touched.name && errors.name}>
      <TextField
        placeholder="Autogenerated by service and project"
        name={`${name}.name`}
        value={values.name || ''}
        onChange={onChange}
        onBlur={onBlur}
      />
    </Field>
  );
};

export default Name;
